// @generated by protoc-gen-es v2.10.1 with parameter "target=ts"
// @generated from file bffuser/v1/procurement_plan_service.proto (package bffuser.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { AreaCode } from "../../bfftypes/v1/area_pb";
import { file_bfftypes_v1_area } from "../../bfftypes/v1/area_pb";
import type { PlanSubmissionDownloadFormat, PlanSubmissionStatus, PlanTimeframe } from "../../bfftypes/v1/plan_submission_pb";
import { file_bfftypes_v1_plan_submission } from "../../bfftypes/v1/plan_submission_pb";
import type { PresignedHttpRequest } from "../../bfftypes/v1/presigned_http_request_pb";
import { file_bfftypes_v1_presigned_http_request } from "../../bfftypes/v1/presigned_http_request_pb";
import type { ProcurementPlanDetail, ProcurementPlanRow, RetailerInfo } from "./procurement_plan_model_pb";
import { file_bffuser_v1_procurement_plan_model } from "./procurement_plan_model_pb";
import { file_buf_validate_validate } from "../../buf/validate/validate_pb";
import type { Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { Date } from "../../google/type/date_pb";
import { file_google_type_date } from "../../google/type/date_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file bffuser/v1/procurement_plan_service.proto.
 */
export const file_bffuser_v1_procurement_plan_service: GenFile = /*@__PURE__*/
  fileDesc("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", [file_bfftypes_v1_area, file_bfftypes_v1_plan_submission, file_bfftypes_v1_presigned_http_request, file_bffuser_v1_procurement_plan_model, file_buf_validate_validate, file_google_protobuf_timestamp, file_google_type_date]);

/**
 * ListProcurementPlansRequest carries filtering criteria for the list.
 *
 * @generated from message bffuser.v1.ListProcurementPlansRequest
 */
export type ListProcurementPlansRequest = Message<"bffuser.v1.ListProcurementPlansRequest"> & {
  /**
   * Planning horizon to filter by. Absent (= optional field not set) returns
   * rows for every timeframe (翌日(当日) / 翌日 / 翌々日 combined, procurement-plan-list.md
   * AC-001/AC-002 3断面横断表示); when present, UNSPECIFIED is rejected and
   * the result is narrowed to the single timeframe.
   *
   * @generated from field: optional bfftypes.v1.PlanTimeframe timeframe = 1;
   */
  timeframe?: PlanTimeframe;

  /**
   * Start date of the target period to filter by.
   *
   * @generated from field: google.type.Date target_period_start_date = 2;
   */
  targetPeriodStartDate?: Date;

  /**
   * Optional area filter. Empty = all areas (OR condition across the
   * selected areas when non-empty). UNSPECIFIED is rejected as a repeated
   * item (procurement-plan-list-area-multi-select design AC-01/AC-04).
   *
   * @generated from field: repeated bfftypes.v1.AreaCode area_codes = 3;
   */
  areaCodes: AreaCode[];

  /**
   * When false (= default / zero value), only the latest version of each
   * submission is returned. When true, all versions are returned.
   *
   * @generated from field: bool include_all_versions = 4;
   */
  includeAllVersions: boolean;
};

/**
 * Describes the message bffuser.v1.ListProcurementPlansRequest.
 * Use `create(ListProcurementPlansRequestSchema)` to create a new message.
 */
export const ListProcurementPlansRequestSchema: GenMessage<ListProcurementPlansRequest> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_procurement_plan_service, 0);

/**
 * @generated from message bffuser.v1.ListProcurementPlansResponse
 */
export type ListProcurementPlansResponse = Message<"bffuser.v1.ListProcurementPlansResponse"> & {
  /**
   * @generated from field: repeated bffuser.v1.ProcurementPlanRow rows = 1;
   */
  rows: ProcurementPlanRow[];
};

/**
 * Describes the message bffuser.v1.ListProcurementPlansResponse.
 * Use `create(ListProcurementPlansResponseSchema)` to create a new message.
 */
export const ListProcurementPlansResponseSchema: GenMessage<ListProcurementPlansResponse> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_procurement_plan_service, 1);

/**
 * @generated from message bffuser.v1.GetProcurementPlanDetailRequest
 */
export type GetProcurementPlanDetailRequest = Message<"bffuser.v1.GetProcurementPlanDetailRequest"> & {
  /**
   * UUID surrogate primary key of the plan submission to fetch.
   *
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message bffuser.v1.GetProcurementPlanDetailRequest.
 * Use `create(GetProcurementPlanDetailRequestSchema)` to create a new message.
 */
export const GetProcurementPlanDetailRequestSchema: GenMessage<GetProcurementPlanDetailRequest> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_procurement_plan_service, 2);

/**
 * @generated from message bffuser.v1.GetProcurementPlanDetailResponse
 */
export type GetProcurementPlanDetailResponse = Message<"bffuser.v1.GetProcurementPlanDetailResponse"> & {
  /**
   * @generated from field: bffuser.v1.ProcurementPlanDetail detail = 1;
   */
  detail?: ProcurementPlanDetail;

  /**
   * Deprecated: superseded by ProcurementPlanDetail.retailer_breakdowns
   * (procurement-plan-retailer-breakdown design). The BFF handler no longer
   * populates this field (always empty).
   *
   * @generated from field: repeated bffuser.v1.RetailerInfo retailers = 2 [deprecated = true];
   * @deprecated
   */
  retailers: RetailerInfo[];
};

/**
 * Describes the message bffuser.v1.GetProcurementPlanDetailResponse.
 * Use `create(GetProcurementPlanDetailResponseSchema)` to create a new message.
 */
export const GetProcurementPlanDetailResponseSchema: GenMessage<GetProcurementPlanDetailResponse> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_procurement_plan_service, 3);

/**
 * GetProcurementPlanByFilterRequest identifies a demand-procurement plan
 * submission by filter criteria instead of its UUID.
 *
 * @generated from message bffuser.v1.GetProcurementPlanByFilterRequest
 */
export type GetProcurementPlanByFilterRequest = Message<"bffuser.v1.GetProcurementPlanByFilterRequest"> & {
  /**
   * Start date of the target period to look up.
   *
   * @generated from field: google.type.Date target_period_start_date = 1;
   */
  targetPeriodStartDate?: Date;

  /**
   * Supply area to look up.
   *
   * @generated from field: bfftypes.v1.AreaCode area_code = 2;
   */
  areaCode: AreaCode;

  /**
   * OCCTO BG code of the submission entity.
   *
   * @generated from field: string bg_code = 3;
   */
  bgCode: string;

  /**
   * Planning horizon to narrow the lookup to when multiple submissions could
   * otherwise match the same (target_period_start_date, area_code, bg_code)
   * tuple (procurement-plan-detail-filter design §4 "断面選択"). Absent
   * returns the most recent submission across the 3 daily sections, where
   * recency is 最終更新日時 (GREATEST(file_created_at, the time the submission
   * status last changed) DESC, then version DESC) — the backend's single
   * 「最新版」 resolution shared with the list screens (the list's 「最新のみ表示」
   * ON row), not a BFF-local comparison.
   *
   * @generated from field: optional bfftypes.v1.PlanTimeframe timeframe = 4;
   */
  timeframe?: PlanTimeframe;
};

/**
 * Describes the message bffuser.v1.GetProcurementPlanByFilterRequest.
 * Use `create(GetProcurementPlanByFilterRequestSchema)` to create a new message.
 */
export const GetProcurementPlanByFilterRequestSchema: GenMessage<GetProcurementPlanByFilterRequest> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_procurement_plan_service, 4);

/**
 * @generated from message bffuser.v1.GetProcurementPlanByFilterResponse
 */
export type GetProcurementPlanByFilterResponse = Message<"bffuser.v1.GetProcurementPlanByFilterResponse"> & {
  /**
   * @generated from field: bffuser.v1.ProcurementPlanDetail detail = 1;
   */
  detail?: ProcurementPlanDetail;

  /**
   * Deprecated: superseded by ProcurementPlanDetail.retailer_breakdowns
   * (procurement-plan-retailer-breakdown design). The BFF handler no longer
   * populates this field (always empty).
   *
   * @generated from field: repeated bffuser.v1.RetailerInfo retailers = 2 [deprecated = true];
   * @deprecated
   */
  retailers: RetailerInfo[];
};

/**
 * Describes the message bffuser.v1.GetProcurementPlanByFilterResponse.
 * Use `create(GetProcurementPlanByFilterResponseSchema)` to create a new message.
 */
export const GetProcurementPlanByFilterResponseSchema: GenMessage<GetProcurementPlanByFilterResponse> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_procurement_plan_service, 5);

/**
 * CreateProcurementPlanRequest triggers creation of a new demand-procurement
 * plan submission. All enum fields reject UNSPECIFIED (= 0).
 *
 * @generated from message bffuser.v1.CreateProcurementPlanRequest
 */
export type CreateProcurementPlanRequest = Message<"bffuser.v1.CreateProcurementPlanRequest"> & {
  /**
   * Planning horizon for this submission.
   *
   * @generated from field: bfftypes.v1.PlanTimeframe timeframe = 1;
   */
  timeframe: PlanTimeframe;

  /**
   * Supply area this submission is bound to.
   *
   * @generated from field: bfftypes.v1.AreaCode area_code = 2;
   */
  areaCode: AreaCode;

  /**
   * Start date of the target period covered by this submission.
   *
   * @generated from field: google.type.Date target_period_start_date = 3;
   */
  targetPeriodStartDate?: Date;

  /**
   * OCCTO BG code of the submission entity (balancing group).
   *
   * @generated from field: string submission_entity_code = 4;
   */
  submissionEntityCode: string;
};

/**
 * Describes the message bffuser.v1.CreateProcurementPlanRequest.
 * Use `create(CreateProcurementPlanRequestSchema)` to create a new message.
 */
export const CreateProcurementPlanRequestSchema: GenMessage<CreateProcurementPlanRequest> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_procurement_plan_service, 6);

/**
 * @generated from message bffuser.v1.CreateProcurementPlanResponse
 */
export type CreateProcurementPlanResponse = Message<"bffuser.v1.CreateProcurementPlanResponse"> & {
  /**
   * UUID surrogate primary key of the newly created plan submission.
   *
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * Status of the submission immediately after creation (= GENERATING).
   * The backend worker transitions this to GENERATED once assembly is complete.
   *
   * @generated from field: bfftypes.v1.PlanSubmissionStatus status = 2;
   */
  status: PlanSubmissionStatus;
};

/**
 * Describes the message bffuser.v1.CreateProcurementPlanResponse.
 * Use `create(CreateProcurementPlanResponseSchema)` to create a new message.
 */
export const CreateProcurementPlanResponseSchema: GenMessage<CreateProcurementPlanResponse> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_procurement_plan_service, 7);

/**
 * DownloadProcurementPlanXmlRequest specifies the plan submission whose XML
 * archive should be retrieved.
 *
 * @generated from message bffuser.v1.DownloadProcurementPlanXmlRequest
 */
export type DownloadProcurementPlanXmlRequest = Message<"bffuser.v1.DownloadProcurementPlanXmlRequest"> & {
  /**
   * UUID surrogate primary key of the plan submission to download.
   *
   * @generated from field: string plan_submission_id = 1;
   */
  planSubmissionId: string;

  /**
   * 2 is intentionally unused: format = 3 mirrors the backend internalapi
   * DownloadPlanSubmissionXmlRequest field number.
   * File format of the download. UNSPECIFIED is treated as XML.
   *
   * @generated from field: bfftypes.v1.PlanSubmissionDownloadFormat format = 3;
   */
  format: PlanSubmissionDownloadFormat;
};

/**
 * Describes the message bffuser.v1.DownloadProcurementPlanXmlRequest.
 * Use `create(DownloadProcurementPlanXmlRequestSchema)` to create a new message.
 */
export const DownloadProcurementPlanXmlRequestSchema: GenMessage<DownloadProcurementPlanXmlRequest> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_procurement_plan_service, 8);

/**
 * @generated from message bffuser.v1.DownloadProcurementPlanXmlResponse
 */
export type DownloadProcurementPlanXmlResponse = Message<"bffuser.v1.DownloadProcurementPlanXmlResponse"> & {
  /**
   * Raw bytes of the download: the plan XML (OCCTO BP-規格 format) for
   * UNSPECIFIED / XML, or a ZIP holding that XML as a single entry for ZIP.
   *
   * @generated from field: bytes content = 1;
   */
  content: Uint8Array;

  /**
   * OCCTO BP-規格ファイル名 (e.g. "W6_0250_20260602_00_47633_3.xml"; the
   * extension is ".zip" for the ZIP format).
   *
   * @generated from field: string file_name = 2;
   */
  fileName: string;

  /**
   * MIME type of the content ("application/xml", or "application/zip" for ZIP).
   *
   * @generated from field: string content_type = 3;
   */
  contentType: string;
};

/**
 * Describes the message bffuser.v1.DownloadProcurementPlanXmlResponse.
 * Use `create(DownloadProcurementPlanXmlResponseSchema)` to create a new message.
 */
export const DownloadProcurementPlanXmlResponseSchema: GenMessage<DownloadProcurementPlanXmlResponse> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_procurement_plan_service, 9);

/**
 * SubmitProcurementPlanRequest specifies the plan submission version to
 * submit.
 *
 * @generated from message bffuser.v1.SubmitProcurementPlanRequest
 */
export type SubmitProcurementPlanRequest = Message<"bffuser.v1.SubmitProcurementPlanRequest"> & {
  /**
   * UUID surrogate primary key of the plan submission to submit.
   *
   * @generated from field: string plan_id = 1;
   */
  planId: string;
};

/**
 * Describes the message bffuser.v1.SubmitProcurementPlanRequest.
 * Use `create(SubmitProcurementPlanRequestSchema)` to create a new message.
 */
export const SubmitProcurementPlanRequestSchema: GenMessage<SubmitProcurementPlanRequest> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_procurement_plan_service, 10);

/**
 * @generated from message bffuser.v1.SubmitProcurementPlanResponse
 */
export type SubmitProcurementPlanResponse = Message<"bffuser.v1.SubmitProcurementPlanResponse"> & {
  /**
   * Status of the submission immediately after the enqueue (= SUBMITTING on
   * success).
   *
   * @generated from field: bfftypes.v1.PlanSubmissionStatus status = 1;
   */
  status: PlanSubmissionStatus;

  /**
   * Optimistic-lock baseline for round-trip use by a subsequent mutation.
   *
   * @generated from field: google.protobuf.Timestamp updated_at = 2;
   */
  updatedAt?: Timestamp;

  /**
   * UUID surrogate primary key of the plan submission the enqueue actually
   * wrote: the SAME id as the request for the in-place route, or the newly
   * minted generation's id when the source was a committed INCONSISTENT
   * version. The frontend must use this id (not the request plan_id) for its
   * next round-trip fetch / navigation, since the request id may now
   * reference a frozen INCONSISTENT row that is no longer the latest
   * version.
   *
   * @generated from field: string plan_id = 3;
   */
  planId: string;
};

/**
 * Describes the message bffuser.v1.SubmitProcurementPlanResponse.
 * Use `create(SubmitProcurementPlanResponseSchema)` to create a new message.
 */
export const SubmitProcurementPlanResponseSchema: GenMessage<SubmitProcurementPlanResponse> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_procurement_plan_service, 11);

/**
 * IssueProcurementPlanXmlUploadUrlRequest carries nothing: kind is fixed to
 * DEMAND_PROCUREMENT by the BFF handler.
 *
 * @generated from message bffuser.v1.IssueProcurementPlanXmlUploadUrlRequest
 */
export type IssueProcurementPlanXmlUploadUrlRequest = Message<"bffuser.v1.IssueProcurementPlanXmlUploadUrlRequest"> & {
};

/**
 * Describes the message bffuser.v1.IssueProcurementPlanXmlUploadUrlRequest.
 * Use `create(IssueProcurementPlanXmlUploadUrlRequestSchema)` to create a new message.
 */
export const IssueProcurementPlanXmlUploadUrlRequestSchema: GenMessage<IssueProcurementPlanXmlUploadUrlRequest> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_procurement_plan_service, 12);

/**
 * @generated from message bffuser.v1.IssueProcurementPlanXmlUploadUrlResponse
 */
export type IssueProcurementPlanXmlUploadUrlResponse = Message<"bffuser.v1.IssueProcurementPlanXmlUploadUrlResponse"> & {
  /**
   * One-time token to pass to UploadProcurementPlanXml.upload_token.
   *
   * @generated from field: string upload_token = 1;
   */
  uploadToken: string;

  /**
   * Presigned PUT request the browser sends the file to (url / method /
   * headers used unchanged).
   *
   * @generated from field: bfftypes.v1.PresignedHttpRequest upload = 2;
   */
  upload?: PresignedHttpRequest;

  /**
   * Upper bound on the file size in bytes. The browser rejects a larger file
   * before sending it; the object store enforces the same bound.
   *
   * @generated from field: int64 max_content_bytes = 3;
   */
  maxContentBytes: bigint;
};

/**
 * Describes the message bffuser.v1.IssueProcurementPlanXmlUploadUrlResponse.
 * Use `create(IssueProcurementPlanXmlUploadUrlResponseSchema)` to create a new message.
 */
export const IssueProcurementPlanXmlUploadUrlResponseSchema: GenMessage<IssueProcurementPlanXmlUploadUrlResponse> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_procurement_plan_service, 13);

/**
 * UploadProcurementPlanXmlRequest names the uploaded file by its upload
 * token; the file itself never travels in the request. The BFF handler fixes
 * kind to DEMAND_PROCUREMENT.
 *
 * @generated from message bffuser.v1.UploadProcurementPlanXmlRequest
 */
export type UploadProcurementPlanXmlRequest = Message<"bffuser.v1.UploadProcurementPlanXmlRequest"> & {
  /**
   * Token returned by IssueProcurementPlanXmlUploadUrl for the uploaded file.
   *
   * @generated from field: string upload_token = 2;
   */
  uploadToken: string;
};

/**
 * Describes the message bffuser.v1.UploadProcurementPlanXmlRequest.
 * Use `create(UploadProcurementPlanXmlRequestSchema)` to create a new message.
 */
export const UploadProcurementPlanXmlRequestSchema: GenMessage<UploadProcurementPlanXmlRequest> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_procurement_plan_service, 14);

/**
 * @generated from message bffuser.v1.UploadProcurementPlanXmlResponse
 */
export type UploadProcurementPlanXmlResponse = Message<"bffuser.v1.UploadProcurementPlanXmlResponse"> & {
  /**
   * UUID surrogate primary key of the newly created plan submission.
   *
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * Status of the submission immediately after the import (= GENERATED on
   * success).
   *
   * @generated from field: bfftypes.v1.PlanSubmissionStatus status = 2;
   */
  status: PlanSubmissionStatus;
};

/**
 * Describes the message bffuser.v1.UploadProcurementPlanXmlResponse.
 * Use `create(UploadProcurementPlanXmlResponseSchema)` to create a new message.
 */
export const UploadProcurementPlanXmlResponseSchema: GenMessage<UploadProcurementPlanXmlResponse> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_procurement_plan_service, 15);

/**
 * ProcurementPlanService provides Connect RPCs for the 需要調達計画一覧
 * (demand-procurement plan list) and 需要調達計画詳細 (detail) screens
 * consumed by the frontend.
 *
 * @generated from service bffuser.v1.ProcurementPlanService
 */
export const ProcurementPlanService: GenService<{
  /**
   * ListProcurementPlans returns the demand-procurement plan list-screen
   * rows for the authenticated organization. When include_all_versions is
   * false (= default / zero value), only the latest version of each
   * submission is returned.
   *
   * @generated from rpc bffuser.v1.ProcurementPlanService.ListProcurementPlans
   */
  listProcurementPlans: {
    methodKind: "unary";
    input: typeof ListProcurementPlansRequestSchema;
    output: typeof ListProcurementPlansResponseSchema;
  },
  /**
   * GetProcurementPlanDetail returns the full detail of a single
   * demand-procurement plan submission, including 48-slot demand values,
   * procurement / sales breakdown rows, and the previous submitted version
   * for diff display. All data is returned in a single RPC to minimise
   * round-trips (主要意思決定 §5).
   *
   * @generated from rpc bffuser.v1.ProcurementPlanService.GetProcurementPlanDetail
   */
  getProcurementPlanDetail: {
    methodKind: "unary";
    input: typeof GetProcurementPlanDetailRequestSchema;
    output: typeof GetProcurementPlanDetailResponseSchema;
  },
  /**
   * GetProcurementPlanByFilter looks up a single demand-procurement plan
   * submission by (target_period_start_date, area_code, bg_code[,
   * timeframe]) instead of its UUID, returning the same full detail payload
   * as GetProcurementPlanDetail plus the BG's member (小売事業者) list. Used
   * by the detail screen's filter bar (procurement-plan-detail-filter design
   * §4 主要意思決定 "API 設計") when the user changes the target date or
   * area while viewing a plan. Returns NOT_FOUND when no submission matches
   * the filter.
   *
   * @generated from rpc bffuser.v1.ProcurementPlanService.GetProcurementPlanByFilter
   */
  getProcurementPlanByFilter: {
    methodKind: "unary";
    input: typeof GetProcurementPlanByFilterRequestSchema;
    output: typeof GetProcurementPlanByFilterResponseSchema;
  },
  /**
   * CreateProcurementPlan triggers the creation of a new demand-procurement
   * plan submission. The BFF handler resolves organization_id from the eauth
   * session and forwards the request to the backend CreatePlanSubmission RPC.
   * On success the status is GENERATING; the backend worker transitions it to
   * GENERATED once assembly from the three sources is complete.
   *
   * @generated from rpc bffuser.v1.ProcurementPlanService.CreateProcurementPlan
   */
  createProcurementPlan: {
    methodKind: "unary";
    input: typeof CreateProcurementPlanRequestSchema;
    output: typeof CreateProcurementPlanResponseSchema;
  },
  /**
   * DownloadProcurementPlanXml returns the plan XML content and its OCCTO
   * BP-規格ファイル名 for the specified plan submission. The BFF handler
   * resolves organization_id from the eauth session.
   *
   * @generated from rpc bffuser.v1.ProcurementPlanService.DownloadProcurementPlanXml
   */
  downloadProcurementPlanXml: {
    methodKind: "unary";
    input: typeof DownloadProcurementPlanXmlRequestSchema;
    output: typeof DownloadProcurementPlanXmlResponseSchema;
  },
  /**
   * SubmitProcurementPlan submits a demand-procurement plan submission to the
   * OCCTO portal asynchronously: it enqueues the submission and returns
   * immediately with status SUBMITTING. The BFF handler resolves
   * organization_id from the eauth session and forwards the call to the
   * backend gRPC PlanSubmissionService.EnqueuePlanSubmission RPC. The
   * resident SendWorker settles the enqueued attempt to SUBMITTED / REJECTED
   * / SUBMIT_FAILED; the frontend re-fetches GetProcurementPlanDetail to
   * observe the terminal status.
   *
   * @generated from rpc bffuser.v1.ProcurementPlanService.SubmitProcurementPlan
   */
  submitProcurementPlan: {
    methodKind: "unary";
    input: typeof SubmitProcurementPlanRequestSchema;
    output: typeof SubmitProcurementPlanResponseSchema;
  },
  /**
   * IssueProcurementPlanXmlUploadUrl returns a one-time upload token and a
   * presigned PUT request the browser sends the XML / ZIP to directly, plus
   * the size limit the browser checks before sending. It forwards to the
   * backend gRPC PlanSubmissionService.IssuePlanSubmissionImportUploadUrl,
   * fixed to kind=PLAN_SUBMISSION_KIND_DEMAND_PROCUREMENT; the BFF handler
   * resolves organization_id from the eauth session.
   *
   * @generated from rpc bffuser.v1.ProcurementPlanService.IssueProcurementPlanXmlUploadUrl
   */
  issueProcurementPlanXmlUploadUrl: {
    methodKind: "unary";
    input: typeof IssueProcurementPlanXmlUploadUrlRequestSchema;
    output: typeof IssueProcurementPlanXmlUploadUrlResponseSchema;
  },
  /**
   * UploadProcurementPlanXml synchronously imports the OCCTO 提出フォーマット
   * XML (or a ZIP containing exactly one XML) the browser uploaded with the
   * IssueProcurementPlanXmlUploadUrl response, naming it by upload_token. It
   * forwards to the backend gRPC PlanSubmissionService.ImportPlanSubmission
   * RPC, fixed to kind=PLAN_SUBMISSION_KIND_DEMAND_PROCUREMENT. The BFF
   * handler resolves organization_id from the eauth session; file_name is not
   * carried (the completion dialog uses the frontend's local File.name, not a
   * server round-trip). On success the returned status is always GENERATED
   * (the import is synchronous — contrast CreateProcurementPlan's GENERATING).
   *
   * @generated from rpc bffuser.v1.ProcurementPlanService.UploadProcurementPlanXml
   */
  uploadProcurementPlanXml: {
    methodKind: "unary";
    input: typeof UploadProcurementPlanXmlRequestSchema;
    output: typeof UploadProcurementPlanXmlResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_bffuser_v1_procurement_plan_service, 0);

